import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useGetUserRegion } from '../../../hooks/use-user-region';

function getLanguageFromSalesforceUrl(
  urlLanguage: string,
  urlRegion: string
): string {
  if (urlRegion === 'US' && urlLanguage === 'es_MX') {
    return 'es_419';
  }
  return urlLanguage;
}

function useLanguageFromUrl(): {
  language: string | undefined;
} {
  const { lng: urlLanguage } = useParams<{ lng: string }>();
  const urlRegion = useGetUserRegion();

  const language = useMemo(() => {
    if (!urlLanguage || !urlRegion) {
      return undefined;
    }
    return getLanguageFromSalesforceUrl(urlLanguage, urlRegion);
  }, [urlLanguage, urlRegion]);

  const { i18n } = useTranslation();

  useEffect(() => {
    if (language) {
      i18n.changeLanguage(language);
    }
  }, [i18n, language]);

  return { language };
}

export { useLanguageFromUrl };
